import { render, staticRenderFns } from "./OAuthRegister.vue?vue&type=template&id=0f96619a&scoped=true&"
import script from "./OAuthRegister.vue?vue&type=script&lang=js&"
export * from "./OAuthRegister.vue?vue&type=script&lang=js&"
import style0 from "./OAuthRegister.vue?vue&type=style&index=0&id=0f96619a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96619a",
  null
  
)

export default component.exports